// extracted by mini-css-extract-plugin
module.exports = {"modal":"GratitudeBanner_modal__YlWJm","title":"GratitudeBanner_title__1E44p"};